import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectorSimpleFactory } from "../logic";
function viajeSearchString(x: models.ViajeEADDto) {
    return `${x.Folio} ${x.NombreSucursal} ${x.NombreCamion} ${models.StatusViajeEAD[x.Status]} ${x.NombreRuta} ${x.NombreChofer} `;
}

class ViajeEADItem extends React.PureComponent<{ value: models.ViajeEADDto }> {
    render() {
        const x = this.props.value;
        return (
            <div>
                <span>
                    <b>Folio:</b>{" "}{x.Folio}{", "}
                    <b>Status:</b>{" "}{models.StatusViajeEAD[x.Status]}
                </span>
                <br/>
                <span>
                    <b>Sucursal:</b>{" "}{x.NombreSucursal}{", "}
                    <b>Camión:</b>{" "}{x.NombreCamion}{", "}
                </span>
                <br/>
                <span>
                    <b>Chofer:</b>{" "}{x.NombreChofer}{", "}
                    <b>Ruta:</b>{" "}{x.NombreRuta}
                </span>
            </div>
        )
    }
}

export const ViajeEAD = 
    SelectorSimpleFactory(
        observeResource(resources.ViajeEAD.ConsultarViajes, { }),
        x => x.IdRegistro,
        x => ({
            label: viajeSearchString(x),
            view: <ViajeEADItem value={x} />
        })
    );


// WEBPACK FOOTER //
// ./app/features/selectores/items/viajeead.tsx